import { render } from "./ClassroomPlaceholder.vue?vue&type=template&id=2d6c433d&scoped=true"
import script from "./ClassroomPlaceholder.vue?vue&type=script&lang=js"
export * from "./ClassroomPlaceholder.vue?vue&type=script&lang=js"

import "./ClassroomPlaceholder.vue?vue&type=style&index=0&id=2d6c433d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6c433d"]])

export default __exports__